import http from 'utils/http';
import { PROJECT_URL } from 'constants/endpoints';
import { GenericResponse } from 'interface/common';

export interface Project {
  id: number;
  name: string;
}

/**
 * Fetch all projects.
 */
export async function fetchProjects(params = {}) {
  const data = await http.get<GenericResponse<Project>>(PROJECT_URL, { params });

  return data;
}
